import axios from "axios";
import React, { useState, useEffect } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";

export default function EditProfileModal({ show, onClose, onSave, appUser, user }) {
  const [firstName, setFirstName] = useState(appUser?.firstName || "");
  const [lastName, setLastName] = useState(appUser?.lastName || "");
  const [isLoading, setIsLoading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    setFirstName(appUser?.firstName || "");
    setLastName(appUser?.lastName || "");
    setIsComplete(false);
  }, [appUser, show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.put(
        `${ApiConnectionString}/api/account`,
        { firstName, lastName },
        { headers: { Authorization: `bearer ${user.token}` } }
      );

      if (response.status === 200) {
        setIsComplete(true);
        onSave({ firstName, lastName });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title brand-purple">
                {isComplete ? "Updated" : "Edit your name"}
              </h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            {isComplete ? (
              <div className="modal-body text-center py-4">
                <div className="alert alert-success mb-4">
                  Your name has been updated.
                </div>

                <p className="text-muted mb-4">You can now close this window.</p>

                <button className="btn brand-purple-inline" onClick={onClose}>
                  Close
                </button>
              </div>
            ) : (
              <div className="modal-body">
                <form onSubmit={handleSubmit}>

                  <div className="mb-3">
                    <label className="form-label fw-semibold brand-purple">
                      First name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold brand-purple">
                      Last name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="alert alert-info">
                    For any other account changes please contact support at{" "}
                    <strong>info@bcsoftware.com</strong>.
                  </div>

                  <div className="modal-footer px-0">
                    <button
                      type="button"
                      className="btn brand-purple-outline"
                      onClick={onClose}
                      disabled={isLoading}
                    >
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className="btn brand-purple-inline"
                      disabled={isLoading}
                    >
                      {isLoading ? "Saving..." : "Save changes"}
                    </button>
                  </div>
                </form>
              </div>
            )}

          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
}
